import { Head, usePage } from "@inertiajs/react";
import FlashStack from "@/components/layout/FlashStack";
import CityPage from "@/components/events/CityPage";
import type { PublicProps } from "@/types";
import type { SatelliteEvent, EventRsvp } from "@/interfaces/satellite_event";

// The public city page. Everything it draws lives in CityPage, which the
// organizer's editor renders too - one definition of the layout, so a preview
// cannot drift from what an attendee is served.
export default function EventShow({
  event,
  my_rsvp,
  is_organizer,
  age_range,
}: {
  event: SatelliteEvent;
  my_rsvp: EventRsvp | null;
  is_organizer: boolean;
  age_range: { min: number; max: number };
}) {
  const program = usePage<PublicProps>().props.program;

  return (
    <>
      <Head title={`${program.name} ${event.city ?? event.name}`} />

      {/* The hero takes an email address, so its confirmation has to land
          somewhere the person can see it. */}
      <FlashStack />

      <CityPage
        event={event}
        page={event.page ?? null}
        myRsvp={my_rsvp}
        isOrganizer={is_organizer}
        ageRange={age_range}
      />
    </>
  );
}
